import { render, staticRenderFns } from "./workshift.vue?vue&type=template&id=77b3bea5&scoped=true&"
import script from "./workshift.vue?vue&type=script&lang=js&"
export * from "./workshift.vue?vue&type=script&lang=js&"
import style0 from "./workshift.vue?vue&type=style&index=0&id=77b3bea5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b3bea5",
  null
  
)

export default component.exports